/** Statuts Clapay / Nowallet — aligné mobileAPI + app Feli. */

const CONFIRMED = new Set(['SUCCESSFUL', 'SUCCESS']);

const PENDING = new Set([
  'INITIATEFROMCLIENT',
  'INITIALIZATION',
  'INITIALISATION',
  'INITIALIZING',
  'PENDING',
  'PROCESSING',
  'IN_PROGRESS',
]);

const FAILED = new Set([
  'FAILED',
  'CLOSED',
  'CANCELLED',
  'CANCELED',
  'EXPIRED',
  'UNCOMPLETED',
  'UNKNOWN',
]);

export const normalizePaymentStatus = (status) =>
  (status || '').trim().toUpperCase();

export const isPaymentConfirmed = (status) =>
  CONFIRMED.has(normalizePaymentStatus(status));

export const isPaymentPending = (status) =>
  PENDING.has(normalizePaymentStatus(status));

export const isPaymentFailed = (status) =>
  FAILED.has(normalizePaymentStatus(status));

export const canConfirmDelivery = (status) =>
  isPaymentConfirmed(status);

export const paymentStatusLabel = (status) => {
  const s = normalizePaymentStatus(status);
  const labels = {
    SUCCESSFUL: 'Payé',
    SUCCESS: 'Payé',
    INITIATEFROMCLIENT: 'Initialisé côté client',
    INITIALIZATION: 'Initialisation en cours',
    INITIALISATION: 'Initialisation en cours',
    INITIALIZING: 'Initialisation en cours',
    PENDING: 'En attente',
    PROCESSING: 'Traitement en cours',
    IN_PROGRESS: 'Traitement en cours',
    FAILED: 'Échec',
    CLOSED: 'Annulé',
    CANCELLED: 'Annulé',
    CANCELED: 'Annulé',
    EXPIRED: 'Expiré',
    UNCOMPLETED: 'Incomplet',
    UNKNOWN: 'Inconnu',
  };
  return labels[s] || (s || 'En attente');
};

export const paymentStatusMessage = (status) => {
  const s = normalizePaymentStatus(status);
  if (isPaymentConfirmed(s)) {
    return 'Paiement confirmé. Création de votre livraison…';
  }
  if (isPaymentPending(s)) {
    const messages = {
      INITIATEFROMCLIENT:
        'Paiement initié sur votre téléphone. Validez la transaction Mobile Money puis patientez.',
      INITIALIZATION: 'Paiement en cours d\'initialisation. Veuillez patienter…',
      INITIALISATION: 'Paiement en cours d\'initialisation. Veuillez patienter…',
      INITIALIZING: 'Paiement en cours d\'initialisation. Veuillez patienter…',
      PENDING: 'Paiement en attente de confirmation par l\'opérateur…',
      PROCESSING: 'Paiement en cours de traitement…',
      IN_PROGRESS: 'Paiement en cours de traitement…',
    };
    return messages[s] || 'Paiement en cours. Ne fermez pas cette page.';
  }
  if (isPaymentFailed(s)) {
    const messages = {
      FAILED: 'Le paiement a échoué. Vous pouvez réessayer.',
      CLOSED: 'Le paiement a été annulé ou fermé.',
      CANCELLED: 'Le paiement a été annulé.',
      CANCELED: 'Le paiement a été annulé.',
      EXPIRED: 'Le délai de paiement est expiré.',
      UNCOMPLETED: 'Paiement incomplet. Veuillez réessayer.',
      UNKNOWN: 'Statut de paiement inconnu.',
    };
    return messages[s] || 'Paiement non abouti.';
  }
  return `Statut : ${paymentStatusLabel(s)}. Vérification en cours…`;
};

/** Fusionne la réponse API avec les champs calculés côté client si absents. */
export const enrichPaymentCheckResponse = (data = {}) => {
  const status = data.status;
  return {
    ...data,
    status_label: data.status_label || paymentStatusLabel(status),
    status_message: data.status_message || paymentStatusMessage(status),
    can_confirm_delivery:
      data.can_confirm_delivery ?? canConfirmDelivery(status),
    is_pending: data.is_pending ?? isPaymentPending(status),
    is_failed: data.is_failed ?? isPaymentFailed(status),
    already_used: Boolean(data.already_used ?? data.expedition_id),
  };
};
